/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { 
  getFirestore, collection, addDoc, doc, deleteDoc, updateDoc,
  onSnapshot, query, getDoc, setDoc, increment
} from 'firebase/firestore';
import { 
  getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged 
} from 'firebase/auth';
import { 
  getStorage, ref, uploadBytes, getDownloadURL 
} from 'firebase/storage';
import { 
  Music, MapPin, Instagram, 
  Lock, Plus, Trash2, ExternalLink, Guitar, 
  Menu, X, PlayCircle, UploadCloud, Loader, Moon, Sun, Globe,
  Code, Save, AlertCircle, LogOut, Edit2, Check, Eye
} from 'lucide-react';

// --- 1. KONFIGURATION & KONSTANTEN ---

const LOGO_URL = process.env.PUBLIC_URL + "/LadinTransparent.png";
const INTRO_VIDEO_URL = process.env.PUBLIC_URL + "/LadinVideo.mp4";
const SUPER_ADMIN_UID = "OQgo5nXVVKQES4Vj0ShpXXb18Xt1";
const APP_ID = 'ladin-musikverein-app';

const firebaseConfig = {
  apiKey: "AIzaSyDdho62hE52qFjezxn8jvmYIhZXi3mCdjU",
  authDomain: "by-myflix.firebaseapp.com",
  databaseURL: "https://by-myflix-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "by-myflix",
  storageBucket: "by-myflix.firebasestorage.app",
  messagingSenderId: "710197132052",
  appId: "1:710197132052:web:b0eaba91471e52f5a7a001",
  measurementId: "G-RXMRYLGVJE"
};

// Init Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Default Posts
const DEFAULT_POSTS = [];

const translations = {
  de: {
    nav: { home: 'Home', about: 'Über Uns', news: 'Aktuelles', contact: 'Kontakt' },
    hero: { badge: 'Wien Favoriten', title1: 'Musik verbindet', title2: 'Kultur & Leidenschaft', desc: 'Willkommen im Ladin Musikverein. Ihr Zentrum für professionellen Unterricht in', saz: 'Saz (Bağlama)', and: 'und', guitar: 'Gitarre', inWien: 'in Wien.', cta: 'Jetzt Anmelden', insta: 'Instagram folgen' },
    about: { title: 'Unsere Instrumente', desc: 'Seit über 20 Jahren stehen wir für Qualität und Leidenschaft. Wir bieten professionellen Unterricht für Anfänger und Fortgeschrittene, basierend auf jahrzehntelanger Erfahrung in einer freundlichen und motivierenden Atmosphäre.', sazTitle: 'Saz (Bağlama)', sazDesc: 'Die Langhalslaute ist das Herzstück der türkischen Volksmusik. In unserem Unterricht lernen Sie nicht nur die Technik, sondern auch die kulturelle Bedeutung und die emotionale Tiefe dieses wunderbaren Instruments. Vom Notenlesen bis zum freien Spiel.', sazList: ['Einzel- & Gruppenunterricht', 'Traditionelle Volkslieder', 'Moderne Spieltechniken'], guitarTitle: 'Gitarre', guitarDesc: 'Das vielseitigste Instrument der Welt. Unser Gitarrenunterricht deckt verschiedene Stile ab, von klassischer Konzertgitarre bis hin zu Akkordbegleitung für Volksmusik und Pop. Entwickeln Sie Ihr Rhythmusgefühl.', guitarList: ['Akkordlehre & Harmonielehre', 'Liedbegleitung', 'Fingerpicking Techniken'] },
    feed: { title: 'Aktuelles vom Verein', subtitle: 'Eindrücke aus dem Unterricht und Veranstaltungen', empty: 'Noch keine Beiträge vorhanden.', emptySub: 'Der Admin kann im Admin-Panel Beiträge hinzufügen.', new: 'Neu', video: 'Video' },
    contact: { title: 'Besuchen Sie uns', desc: 'Haben Sie Fragen zum Unterricht oder möchten Sie sich anmelden? Kommen Sie vorbei oder schreiben Sie uns über Social Media.', addressTitle: 'Adresse', socialTitle: 'Social Media' },
    footer: { rights: 'Alle Rechte vorbehalten.' },
    admin: { loginTitle: 'Admin Login', email: 'E-Mail', password: 'Passwort', loginBtn: 'Anmelden', dashboard: 'Admin Dashboard', logout: 'Abmelden', newPost: 'Neuen Beitrag erstellen', type: 'Typ', linkOriginal: 'Link zum Original (optional)', imageUpload: 'Bild hochladen', selectFile: 'Datei auswählen', orUrl: 'ODER URL EINGEBEN', videoUrl: 'Video / Thumbnail URL', embedLabel: 'Embed Code (HTML)', embedPlaceholder: 'Füge hier den HTML-Embed Code ein...', priorityLabel: 'Position (Priorität)', priorityHelp: 'Höhere Zahlen erscheinen oben', descLabel: 'Beschreibung', descPlaceholder: 'Was passiert auf dem Bild?', publish: 'Veröffentlichen', uploading: 'Wird hochgeladen...', activePosts: 'Aktive Beiträge', delete: 'Löschen', saveOrder: 'Speichern', visitors: 'Seitenaufrufe' }
  },
  tr: {
    nav: { home: 'Ana Sayfa', about: 'Hakkımızda', news: 'Haberler', contact: 'İletişim' },
    hero: { badge: 'Viyana Favoriten', title1: 'Müzik birleştirir', title2: 'Kültür ve Tutku', desc: 'Ladin Müzik Derneği\'ne hoş geldiniz. Viyana\'da profesyonel', saz: 'Saz (Bağlama)', and: 've', guitar: 'Gitar', inWien: 'eğitim merkeziniz.', cta: 'Şimdi Kayıt Ol', insta: 'Instagram Takip' },
    about: { title: 'Enstrümanlarımız', desc: '20 yılı aşkın süredir kalite ve tutkuyla hizmet veriyoruz. Onlarca yıllık tecrübeye dayanarak, samimi ve motive edici bir ortamda yeni başlayanlar ve ileri düzeydekiler için profesyonel dersler sunuyoruz.', sazTitle: 'Saz (Bağlama)', sazDesc: 'Uzun saplı saz, Türk halk müziğinin kalbidir. Derslerimizde sadece tekniği değil, aynı zamanda bu harika enstrümanın kültürel önemini ve duygusal derinliğini de öğreneceksiniz. Nota okumadan serbest çalmaya kadar.', sazList: ['Bireysel ve Grup Dersleri', 'Geleneksel Halk Türküleri', 'Modern Çalma Teknikleri'], guitarTitle: 'Gitar', guitarDesc: 'Dünyanın en çok yönlü enstrümanı. Gitar derslerimiz, klasik konser gitarından halk müziği ve pop için akor eşliğine kadar çeşitli stilleri kapsar. Ritim duygunuzu geliştirin.', guitarList: ['Akor Bilgisi ve Armoni', 'Şarkı Eşliği', 'Fingerpicking Teknikleri'] },
    feed: { title: 'Dernekten Haberler', subtitle: 'Derslerden ve etkinliklerden izlenimler', empty: 'Henüz gönderi yok.', emptySub: 'Yönetici, yönetici panelinden gönderi ekleyebilir.', new: 'Yeni', video: 'Video' },
    contact: { title: 'Bizi Ziyaret Edin', desc: 'Dersler hakkında sorularınız mı var veya kayıt olmak mı istiyorsunuz? Bize uğrayın veya sosyal medya üzerinden bize yazın.', addressTitle: 'Adres', socialTitle: 'Sosyal Medya' },
    footer: { rights: 'Tüm hakları saklıdır.' },
    admin: { loginTitle: 'Yönetici Girişi', email: 'E-Posta', password: 'Şifre', loginBtn: 'Giriş Yap', dashboard: 'Yönetici Paneli', logout: 'Çıkış Yap', newPost: 'Yeni Gönderi Oluştur', type: 'Tür', linkOriginal: 'Orijinal Link (isteğe bağlı)', imageUpload: 'Resim Yükle', selectFile: 'Dosya Seç', orUrl: 'VEYA URL GİRİN', videoUrl: 'Video / Küçük Resim URL', embedLabel: 'Gömme Kodu (HTML)', embedPlaceholder: 'Gömme kodunu buraya yapıştırın...', priorityLabel: 'Pozisyon (Öncelik)', priorityHelp: 'Yüksek sayılar üstte görünür', descLabel: 'Açıklama', descPlaceholder: 'Resimde ne oluyor?', publish: 'Yayınla', uploading: 'Yükleniyor...', activePosts: 'Aktif Gönderiler', delete: 'Sil', saveOrder: 'Kaydet', visitors: 'Ziyaretçi Sayısı' }
  }
};

// --- 2. SUB-COMPONENTS ---

const Navigation = ({ activeTab, setActiveTab, isDarkMode, toggleDarkMode, lang, toggleLang, t }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = activeTab === 'home';
  // Wenn das mobile Menü offen ist, wollen wir KEINE Hintergrundfarbe auf der Nav-Leiste selbst,
  // damit das Overlay nahtlos wirkt.
  const showSolidNav = (scrolled || !isHome) && !isMobileMenuOpen;

  // Bestimme die Textfarbe dynamisch
  const getNavTextColor = () => {
      // Wenn das Menü offen ist, muss der Text immer sichtbar sein (kontrastreich zum Overlay)
      if (isMobileMenuOpen) return 'text-stone-900 dark:text-stone-100';
      // Wenn gescrollt oder nicht Home, normaler Text
      if (showSolidNav) return 'text-stone-800 dark:text-stone-200';
      // Auf Home (ungescrollt) weiß
      return 'text-white';
  };

  const navTextColor = getNavTextColor();
  const logoText = (isMobileMenuOpen || showSolidNav) ? 'text-amber-600' : 'text-white';

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${showSolidNav ? 'bg-white/95 dark:bg-stone-950/95 backdrop-blur-md shadow-sm py-2' : 'bg-transparent py-4'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          
          {/* Logo Section */}
          <div className="flex-shrink-0 flex items-center cursor-pointer gap-3 z-50 relative" onClick={() => { setActiveTab('home'); setIsMobileMenuOpen(false); }}>
            <img src={LOGO_URL} alt="Ladin Logo" className="h-10 sm:h-12 w-auto object-contain drop-shadow-sm" />
            <span className={`font-bold text-xl sm:text-2xl tracking-tight transition-colors ${logoText}`}>LADIN</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {['home', 'about', 'news', 'contact'].map((itemKey) => (
              <button
                key={itemKey}
                onClick={() => setActiveTab(itemKey)}
                className={`text-sm font-semibold uppercase tracking-wider transition-all duration-200 ${
                  activeTab === itemKey 
                    ? 'text-amber-500 border-b-2 border-amber-500' 
                    : `${navTextColor} hover:text-amber-500`
                }`}
              >
                {t.nav[itemKey]}
              </button>
            ))}
            
            <div className={`flex items-center gap-2 pl-4 border-l ${showSolidNav ? 'border-stone-200 dark:border-stone-700' : 'border-white/30'}`}>
                <button onClick={toggleLang} className={`flex items-center gap-1 p-2 rounded-full transition-colors font-bold text-xs ${navTextColor} hover:bg-black/5 dark:hover:bg-white/10`}>
                    <Globe size={16} /> {lang.toUpperCase()}
                </button>
                <button onClick={toggleDarkMode} className={`p-2 rounded-full transition-colors ${navTextColor} hover:bg-black/5 dark:hover:bg-white/10`}>
                    {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
                </button>
            </div>
          </div>

          {/* Mobile Menu Toggle Button & Language */}
          <div className="md:hidden flex items-center gap-3 z-50 relative">
             <button 
                onClick={toggleLang}
                className={`flex items-center gap-1 p-2 rounded-full transition-colors font-bold text-xs ${navTextColor} hover:bg-black/5 dark:hover:bg-white/10`}
            >
                <Globe size={18} /> {lang.toUpperCase()}
            </button>

            <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
                className={`p-2 transition-colors ${navTextColor}`}
                aria-label="Menu"
            >
              {isMobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
            </button>
          </div>
        </div>
      </div>

      {/* Elegant Full-Screen Mobile Menu Overlay */}
      <div className={`fixed inset-0 z-40 bg-stone-50/95 dark:bg-stone-950/95 backdrop-blur-xl flex flex-col justify-center items-center md:hidden transition-all duration-500 ease-in-out ${isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`}>
           <div className="flex flex-col space-y-8 text-center">
              {['home', 'about', 'news', 'contact'].map((itemKey) => (
                <button
                  key={itemKey}
                  onClick={() => {
                    setActiveTab(itemKey);
                    setIsMobileMenuOpen(false);
                  }}
                  className={`text-3xl font-black uppercase tracking-widest transition-all duration-300 transform ${
                    activeTab === itemKey 
                      ? 'text-amber-600 scale-110' 
                      : 'text-stone-800 dark:text-stone-200 hover:text-amber-500'
                  }`}
                >
                  {t.nav[itemKey]}
                </button>
              ))}
           </div>
           
           {/* Mobile Footer Extras */}
           <div className="mt-16 flex gap-12">
              <button onClick={toggleDarkMode} className="flex flex-col items-center gap-3 text-stone-600 dark:text-stone-400 group">
                   <div className="p-4 bg-white dark:bg-stone-800 rounded-full shadow-xl group-active:scale-95 transition-transform">
                    {isDarkMode ? <Sun size={24} /> : <Moon size={24} />}
                   </div>
                   <span className="text-xs font-bold tracking-widest">{isDarkMode ? 'LIGHT' : 'DARK'}</span>
              </button>
           </div>
      </div>
    </nav>
  );
};

const Hero = ({ setActiveTab, t }) => (
  <div className="relative h-screen flex items-center justify-center overflow-hidden">
    <div className="absolute inset-0 z-0"><video autoPlay loop muted playsInline className="w-full h-full object-cover scale-105"><source src={INTRO_VIDEO_URL} type="video/mp4" /></video><div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-stone-900 dark:to-black"></div></div>
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 rounded-full bg-white/10 border border-white/20 backdrop-blur-md shadow-xl animate-pulse">
            <span className="w-2 h-2 rounded-full bg-amber-500"></span>
            <span className="text-white font-medium text-xs sm:text-sm tracking-widest uppercase">{t.hero.badge}</span>
        </div>
        
        <h1 className="text-5xl sm:text-7xl md:text-8xl font-black text-white tracking-tight mb-8 leading-tight drop-shadow-2xl">
          {t.hero.title1} <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-400 to-amber-600">
            {t.hero.title2}
          </span>
        </h1>
        
        <p className="text-lg sm:text-xl md:text-2xl text-stone-200 mb-10 max-w-3xl mx-auto leading-relaxed drop-shadow-md font-light">
          {t.hero.desc} 
          <span className="text-amber-400 font-semibold"> {t.hero.saz}</span> {t.hero.and} 
          <span className="text-amber-400 font-semibold"> {t.hero.guitar}</span> {t.hero.inWien}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <button 
            onClick={() => setActiveTab('contact')}
            className="px-10 py-4 bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white rounded-full font-bold shadow-xl shadow-amber-900/30 transition-all transform hover:scale-105 active:scale-95"
          >
            {t.hero.cta}
          </button>
          <a 
            href="https://www.instagram.com/ladin_musikverein/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="px-10 py-4 bg-white/5 hover:bg-white/10 border border-white/20 text-white rounded-full font-bold backdrop-blur-sm transition-all transform hover:scale-105 active:scale-95 flex items-center justify-center gap-3"
          >
            <Instagram size={20} />
            {t.hero.insta}
          </a>
        </div>
    </div>
  </div>
);

const About = ({ t }) => (
  <div className="py-32 bg-stone-50 dark:bg-stone-950 transition-colors duration-500" id="ueberuns">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-center mb-16">
        <div className="relative">
            <div className="absolute -inset-4 bg-amber-500/20 rounded-full blur-xl animate-pulse"></div>
            <img src={LOGO_URL} alt="Ladin Musikverein Logo Groß" className="relative h-32 sm:h-40 object-contain drop-shadow-2xl"/>
        </div>
      </div>
      <div className="text-center mb-20">
        <h2 className="text-4xl md:text-5xl font-black text-stone-900 dark:text-white mb-6 tracking-tight">{t.about.title}</h2>
        <div className="w-24 h-1.5 bg-gradient-to-r from-amber-500 to-amber-700 mx-auto rounded-full mb-8"></div>
        <p className="mt-4 text-stone-600 dark:text-stone-300 max-w-3xl mx-auto text-xl leading-relaxed font-light">{t.about.desc}</p>
      </div>
      <div className="grid md:grid-cols-2 gap-8 md:gap-16">
        <div className="group relative overflow-hidden rounded-3xl bg-white dark:bg-stone-900 shadow-xl hover:shadow-2xl hover:shadow-amber-500/10 transition-all duration-500 transform hover:-translate-y-2">
          <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity duration-500 transform group-hover:scale-110"><Music size={200} className="text-amber-700 dark:text-amber-500" /></div>
          <div className="relative p-10 z-10">
            <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/30 rounded-2xl flex items-center justify-center mb-8 text-amber-600 dark:text-amber-500 shadow-inner"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="2"/></svg></div>
            <h3 className="text-3xl font-bold text-stone-900 dark:text-white mb-4">{t.about.sazTitle}</h3><p className="text-stone-600 dark:text-stone-300 leading-relaxed mb-8 text-lg">{t.about.sazDesc}</p>
            <ul className="space-y-4">{t.about.sazList.map((item, index) => (<li key={index} className="flex items-center gap-3 text-stone-700 dark:text-stone-300 font-medium"><span className="w-2 h-2 bg-amber-500 rounded-full shadow-sm"></span>{item}</li>))}</ul>
          </div>
        </div>
        <div className="group relative overflow-hidden rounded-3xl bg-white dark:bg-stone-900 shadow-xl hover:shadow-2xl hover:shadow-amber-500/10 transition-all duration-500 transform hover:-translate-y-2">
          <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity duration-500 transform group-hover:scale-110"><Guitar size={200} className="text-amber-700 dark:text-amber-500" /></div>
          <div className="relative p-10 z-10">
            <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/30 rounded-2xl flex items-center justify-center mb-8 text-amber-600 dark:text-amber-500 shadow-inner"><Guitar size={32} /></div>
            <h3 className="text-3xl font-bold text-stone-900 dark:text-white mb-4">{t.about.guitarTitle}</h3><p className="text-stone-600 dark:text-stone-300 leading-relaxed mb-8 text-lg">{t.about.guitarDesc}</p>
            <ul className="space-y-4">{t.about.guitarList.map((item, index) => (<li key={index} className="flex items-center gap-3 text-stone-700 dark:text-stone-300 font-medium"><span className="w-2 h-2 bg-amber-500 rounded-full shadow-sm"></span>{item}</li>))}</ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Feed = ({ items, t }) => {
  useEffect(() => {
    try {
      const tiktokScriptId = 'tiktok-embed-script';
      const existing = document.getElementById(tiktokScriptId);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.id = tiktokScriptId;
      script.src = 'https://www.tiktok.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
    } catch (e) { console.warn(e); }
  }, [items]);

  return (
    <div className="py-32 bg-white dark:bg-black transition-colors duration-500" id="aktuelles">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 border-b border-stone-100 dark:border-stone-800 pb-8">
          <div>
            <span className="text-amber-600 font-bold tracking-wider uppercase text-sm mb-2 block">Social Hub</span>
            <h2 className="text-4xl md:text-5xl font-black text-stone-900 dark:text-white">{t.feed.title}</h2>
            <p className="text-stone-500 dark:text-stone-400 mt-2 text-lg">{t.feed.subtitle}</p>
          </div>
          <div className="flex gap-4 mt-6 md:mt-0">
              <a href="https://www.tiktok.com/@ladin_musikverein" target="_blank" rel="noopener noreferrer" className="px-6 py-3 bg-stone-900 dark:bg-stone-800 text-white rounded-full hover:bg-black transition-all flex items-center gap-2 shadow-lg hover:shadow-xl"><div className="font-bold text-sm">TikTok</div></a>
              <a href="https://www.instagram.com/ladin_musikverein/" target="_blank" rel="noopener noreferrer" className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:opacity-90 transition-all flex items-center gap-2 shadow-lg hover:shadow-xl"><Instagram size={18}/> <span className="font-bold text-sm">Instagram</span></a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.length === 0 ? (
            <div className="col-span-full text-center py-24 text-stone-400 bg-stone-50 dark:bg-stone-900 rounded-3xl border-2 border-dashed border-stone-200 dark:border-stone-800">
              <p className="text-xl font-medium mb-2">{t.feed.empty}</p>
              <span className="text-sm">{t.feed.emptySub}</span>
            </div>
          ) : (
            items.map((item) => {
              const isEmbed = item.type === 'tiktok_embed' || item.type === 'instagram_embed' || item.type === 'embed';
              return (
                <div key={item.id} className={`bg-stone-50 dark:bg-stone-900 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-stone-100 dark:border-stone-800 flex flex-col ${isEmbed ? 'md:col-span-2 lg:col-span-2' : ''}`}>
                   <div className="relative flex-grow">
                       {isEmbed && item.html ? (
                           <div className="p-0 flex justify-center bg-transparent"><div className="w-full flex justify-center scale-95 origin-top" dangerouslySetInnerHTML={{ __html: item.html }} /></div>
                       ) : (
                           <div className="aspect-[4/3] w-full bg-stone-200 dark:bg-stone-800 relative overflow-hidden group">
                               {item.type === 'image' ? <img src={item.url} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"/> : <video src={item.url} controls className="w-full h-full object-cover"/>}
                               
                               {item.type !== 'video' && (
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-sm">
                                    <a href={item.link || item.url} target="_blank" rel="noopener noreferrer" className="px-6 py-3 bg-white text-stone-900 rounded-full font-bold flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform">
                                        Ansehen <ExternalLink size={16} />
                                    </a>
                                </div>
                               )}
                           </div>
                       )}
                   </div>
                   <div className="p-8 bg-white dark:bg-stone-900 relative z-10">
                     <div className="flex items-center gap-3 mb-3">
                        <span className="px-3 py-1 bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-500 text-xs font-bold uppercase tracking-wider rounded-full">{item.type}</span>
                        <span className="text-xs text-stone-400 font-medium">{t.feed.new}</span>
                     </div>
                     <p className="text-stone-800 dark:text-stone-200 font-medium text-lg leading-relaxed">{item.caption}</p>
                   </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

const Contact = ({ t }) => (
  <div className="bg-stone-950 text-white py-32 relative overflow-hidden" id="kontakt">
    <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-900 to-transparent opacity-50"></div>
    <div className="absolute -top-24 -right-24 w-96 h-96 bg-amber-600/10 rounded-full blur-3xl"></div>
    <div className="absolute top-1/2 -left-24 w-72 h-72 bg-purple-600/10 rounded-full blur-3xl"></div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="grid md:grid-cols-2 gap-16 lg:gap-24 items-center">
        <div>
          <span className="text-amber-500 font-bold tracking-wider uppercase text-sm mb-4 block">Kontakt & Info</span>
          <h2 className="text-4xl md:text-5xl font-black mb-8 leading-tight">{t.contact.title}</h2>
          <p className="text-stone-400 mb-12 leading-relaxed text-lg font-light">{t.contact.desc}</p>
          <div className="space-y-8">
            <div className="flex items-start gap-6 group"><div className="p-4 bg-stone-900 rounded-2xl text-amber-500 group-hover:bg-amber-500 group-hover:text-white transition-colors duration-300 shadow-lg border border-stone-800"><MapPin size={28} /></div><div><h3 className="font-bold text-xl text-white mb-1">{t.contact.addressTitle}</h3><p className="text-stone-400 group-hover:text-stone-300 transition-colors">Eckertgasse 10</p><p className="text-stone-400 group-hover:text-stone-300 transition-colors">1100 Wien, Österreich</p></div></div>
            <div className="flex items-start gap-6 group"><div className="p-4 bg-stone-900 rounded-2xl text-amber-500 group-hover:bg-amber-500 group-hover:text-white transition-colors duration-300 shadow-lg border border-stone-800"><Instagram size={28} /></div><div><h3 className="font-bold text-xl text-white mb-2">{t.contact.socialTitle}</h3><div className="flex flex-col gap-2"><a href="https://www.instagram.com/ladin_musikverein/" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-white transition-colors flex items-center gap-2">@ladin_musikverein <ExternalLink size={14}/></a><a href="https://www.tiktok.com/@ladin_musikverein" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-white transition-colors flex items-center gap-2">TikTok: @ladin_musikverein <ExternalLink size={14}/></a></div></div></div>
          </div>
        </div>
        <div className="h-[500px] w-full rounded-3xl overflow-hidden shadow-2xl border border-stone-800 bg-stone-900 relative group">
            <div className="absolute inset-0 bg-amber-500/0 group-hover:bg-amber-500/5 transition-colors z-10 pointer-events-none"></div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2660.597920803445!2d16.377651711680183!3d48.17594595270966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476d077a58a9e40f%3A0x6e9f5e5f5e5f5e5f!2sEckertgasse%2010%2C%201100%20Wien!5e0!3m2!1sde!2sat!4v1620000000000!5m2!1sde!2sat" width="100%" height="100%" style={{border:0, filter: 'grayscale(100%) invert(90%) contrast(80%)'}} allowFullScreen="" loading="lazy" title="Standort Ladin Musikverein"></iframe>
        </div>
      </div>
    </div>
  </div>
);

const Footer = ({ onAdminClick, t }) => (
  <footer className="bg-black text-stone-500 py-16 border-t border-stone-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-8">
      <div className="flex items-center gap-4"><img src={LOGO_URL} alt="Logo Small" className="h-10 w-10 rounded-full opacity-80 ring-2 ring-stone-800" /><div><span className="text-stone-200 font-bold tracking-wider block">LADIN</span><span className="text-xs text-stone-600">Musikverein Wien</span></div></div>
      <div className="flex gap-8 text-sm font-medium"><a href="#" className="hover:text-white transition-colors">Impressum</a><a href="#" className="hover:text-white transition-colors">Datenschutz</a></div>
      <div className="flex gap-4 items-center"><span className="text-xs text-stone-700">© {new Date().getFullYear()} {t.footer.rights}</span><button onClick={onAdminClick} className="text-stone-800 hover:text-stone-500 transition-colors p-2 rounded-full hover:bg-stone-900"><Lock size={14} /></button></div>
    </div>
  </footer>
);

const AdminLogin = ({ onLogin, t }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        try { await onLogin(email, password); } 
        catch (err) { setError(err.message); }
    };
    return (
        <div className="min-h-screen flex items-center justify-center bg-stone-100 dark:bg-stone-950 px-4">
            <form onSubmit={handleSubmit} className="bg-white dark:bg-stone-900 p-8 rounded-2xl shadow-xl max-w-md w-full border border-gray-100 dark:border-stone-800">
                <div className="flex justify-center mb-8"><div className="p-4 bg-amber-50 rounded-full"><Lock size={32} className="text-amber-600" /></div></div>
                <h2 className="text-2xl font-bold text-center mb-8 text-gray-900 dark:text-white">{t.admin.loginTitle}</h2>
                <div className="space-y-4">
                    <div><label className="block text-sm font-medium text-gray-700 dark:text-stone-400 mb-1 ml-1">{t.admin.email}</label><input className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white transition-all" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="admin@example.com" /></div>
                    <div><label className="block text-sm font-medium text-gray-700 dark:text-stone-400 mb-1 ml-1">{t.admin.password}</label><input className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white transition-all" type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" /></div>
                    {error && <div className="p-3 bg-red-50 text-red-600 text-sm rounded-lg flex items-center gap-2"><AlertCircle size={16}/> {error}</div>}
                    <button type="submit" className="w-full py-3 bg-amber-600 hover:bg-amber-500 text-white rounded-xl font-bold shadow-lg shadow-amber-600/20 transition-all transform hover:-translate-y-1">{t.admin.loginBtn}</button>
                </div>
            </form>
        </div>
    );
};

const AdminPanel = ({ items, onDelete, onAdd, onUpdate, onLogout, t, user, views }) => {
    const [newItem, setNewItem] = useState({ type: 'image', caption: '', url: '', link: '', html: '', order: 0 });
    const [file, setFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editOrderValues, setEditOrderValues] = useState({});
    
    // States for Edit Mode
    const [editingId, setEditingId] = useState(null);
    const [editCaption, setEditCaption] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!user || user.uid !== SUPER_ADMIN_UID) return alert("Keine Berechtigung");
        setIsSubmitting(true);
        try {
            let url = newItem.url;
            if (file && storage) {
                const snap = await uploadBytes(ref(storage, `ladin_files/${Date.now()}_${file.name}`), file);
                url = await getDownloadURL(snap.ref);
            }
            await onAdd({ ...newItem, url, order: Number(newItem.order) });
            setNewItem({ type: 'image', caption: '', url: '', link: '', html: '', order: 0 });
            setFile(null);
            alert("Erfolgreich!");
        } catch (err) { alert(err.message); }
        setIsSubmitting(false);
    };

    const handleUpdateOrder = async (id) => {
        const newOrder = editOrderValues[id];
        if (newOrder !== undefined) { await onUpdate(id, { order: Number(newOrder) }); alert("Position aktualisiert."); }
    };
    
    const startEdit = (item) => {
        setEditingId(item.id);
        setEditCaption(item.caption);
    };
    
    const saveEditCaption = async (id) => {
         await onUpdate(id, { caption: editCaption });
         setEditingId(null);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Wirklich löschen?")) { onDelete(id); }
    };

    return (
        <div className="min-h-screen bg-stone-50 dark:bg-stone-950 p-6">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
                  <div>
                    <h1 className="text-3xl font-black text-gray-900 dark:text-white tracking-tight">{t.admin.dashboard}</h1>
                    <p className="text-stone-500">Verwalte deine Inhalte</p>
                  </div>
                  <div className="flex items-center gap-4">
                     <div className="bg-white dark:bg-stone-900 px-4 py-2 rounded-xl shadow-sm border border-stone-100 dark:border-stone-800 flex items-center gap-3">
                        <div className="p-2 bg-blue-100 text-blue-600 rounded-lg"><Eye size={20} /></div>
                        <div>
                            <p className="text-xs text-gray-500 font-bold uppercase tracking-wider">{t.admin.visitors}</p>
                            <p className="text-xl font-black text-gray-900 dark:text-white">{views || 0}</p>
                        </div>
                    </div>
                    <button onClick={onLogout} className="px-5 py-3 bg-white dark:bg-stone-800 text-red-600 border border-red-100 dark:border-red-900/30 rounded-xl hover:bg-red-50 dark:hover:bg-red-900/20 font-bold flex items-center gap-2 transition-all shadow-sm"><LogOut size={18}/> {t.admin.logout}</button>
                  </div>
                </div>

                {!user && (<div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 flex items-center gap-2"><AlertCircle size={20} /><span>Warnung: Keine Verbindung.</span></div>)}
                
                <div className="grid lg:grid-cols-3 gap-8">
                    <div className="lg:col-span-1">
                        <div className="bg-white dark:bg-stone-900 p-6 rounded-3xl shadow-xl border border-stone-100 dark:border-stone-800 sticky top-6">
                            <h2 className="text-xl font-bold mb-6 flex items-center gap-2 text-gray-900 dark:text-white"><div className="p-2 bg-amber-100 text-amber-600 rounded-lg"><Plus size={20}/></div> {t.admin.newPost}</h2>
                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div><label className="block text-xs font-bold text-stone-500 uppercase mb-1 ml-1">{t.admin.type}</label><select className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-amber-500 outline-none" value={newItem.type} onChange={e=>setNewItem({...newItem, type: e.target.value})}><option value="image">Bild (Upload/URL)</option><option value="embed">Embed Code (HTML)</option><option value="video">Video (URL)</option><option value="tiktok">TikTok Link</option><option value="instagram">Instagram Link</option></select></div>
                                
                                {newItem.type === 'embed' ? (
                                    <div><label className="block text-xs font-bold text-stone-500 uppercase mb-1 ml-1">{t.admin.embedLabel}</label><textarea rows="4" className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white font-mono text-xs focus:ring-2 focus:ring-amber-500 outline-none" placeholder={t.admin.embedPlaceholder} value={newItem.html} onChange={e=>setNewItem({...newItem, html: e.target.value})}/></div>
                                ) : newItem.type === 'image' ? (
                                <div className="space-y-3">
                                    <div><label className="block text-xs font-bold text-stone-500 uppercase mb-1 ml-1">{t.admin.imageUpload}</label><label className="cursor-pointer w-full p-4 border-2 border-dashed border-gray-300 dark:border-stone-700 rounded-xl hover:bg-stone-50 dark:hover:bg-stone-800 flex flex-col items-center justify-center gap-2 transition-colors"><UploadCloud size={24} className="text-amber-500"/><span className="text-sm font-medium text-gray-600 dark:text-stone-400">{file ? file.name : t.admin.selectFile}</span><input type="file" accept="image/*" className="hidden" onChange={(e) => setFile(e.target.files[0])} /></label></div>
                                    <div className="relative"><div className="absolute inset-0 flex items-center"><div className="w-full border-t border-gray-200 dark:border-stone-700"></div></div><div className="relative flex justify-center text-xs uppercase"><span className="bg-white dark:bg-stone-900 px-2 text-stone-400">{t.admin.orUrl}</span></div></div>
                                    <input className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-amber-500 outline-none" type="text" placeholder="https://..." value={newItem.url} onChange={e=>setNewItem({...newItem, url: e.target.value})} />
                                </div>
                                ) : (
                                <input className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-amber-500 outline-none" placeholder={t.admin.videoUrl} value={newItem.url} onChange={e=>setNewItem({...newItem, url: e.target.value})} />
                                )}

                                <div><label className="block text-xs font-bold text-stone-500 uppercase mb-1 ml-1">{t.admin.descLabel}</label><textarea rows="3" className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-amber-500 outline-none" placeholder={t.admin.descPlaceholder} value={newItem.caption} onChange={e=>setNewItem({...newItem, caption: e.target.value})} /></div>
                                
                                <div className="grid grid-cols-2 gap-4">
                                    <div><label className="block text-xs font-bold text-stone-500 uppercase mb-1 ml-1">{t.admin.priorityLabel}</label><input className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-amber-500 outline-none" type="number" value={newItem.order} onChange={e=>setNewItem({...newItem, order: e.target.value})} /></div>
                                    <div><label className="block text-xs font-bold text-stone-500 uppercase mb-1 ml-1">Link (Optional)</label><input className="w-full p-3 border border-gray-200 dark:border-stone-700 rounded-xl bg-stone-50 dark:bg-stone-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-amber-500 outline-none" type="text" value={newItem.link} onChange={e=>setNewItem({...newItem, link: e.target.value})} /></div>
                                </div>

                                <button disabled={isSubmitting} className="w-full p-4 bg-gradient-to-r from-amber-600 to-amber-700 text-white rounded-xl font-bold shadow-lg shadow-amber-600/20 hover:shadow-amber-600/40 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2">{isSubmitting ? <Loader className="animate-spin" size={20}/> : t.admin.publish}</button>
                            </form>
                        </div>
                    </div>

                    {/* List Column */}
                    <div className="lg:col-span-2 space-y-4">
                        {items.map(item => (
                            <div key={item.id} className="bg-white dark:bg-stone-900 p-4 rounded-2xl shadow-sm border border-stone-100 dark:border-stone-800 flex flex-col sm:flex-row gap-6 hover:shadow-md transition-shadow">
                               <div className="w-full sm:w-32 h-32 bg-stone-100 dark:bg-stone-800 rounded-xl overflow-hidden flex-shrink-0 relative">
                                   {item.type === 'image' ? <img src={item.url} className="w-full h-full object-cover" alt="" /> : <div className="w-full h-full flex items-center justify-center text-stone-400"><Code/></div>}
                                   <div className="absolute top-2 left-2 bg-black/50 text-white text-[10px] font-bold px-2 py-1 rounded backdrop-blur-sm uppercase">{item.type}</div>
                               </div>
                               
                               <div className="flex-grow flex flex-col justify-between">
                                    {editingId === item.id ? (
                                        <div className="flex gap-2 mb-2">
                                            <input className="border p-2 rounded flex-grow dark:bg-stone-800 dark:text-white" value={editCaption} onChange={e=>setEditCaption(e.target.value)} />
                                            <button onClick={() => saveEditCaption(item.id)} className="p-2 bg-green-500 text-white rounded"><Check size={16}/></button>
                                            <button onClick={() => setEditingId(null)} className="p-2 bg-stone-300 rounded"><X size={16}/></button>
                                        </div>
                                    ) : (
                                        <p className="font-medium text-lg text-stone-800 dark:text-stone-200 line-clamp-2 mb-2">{item.caption}</p>
                                    )}
                                    
                                    <div className="flex flex-wrap items-center gap-3">
                                        <div className="flex items-center gap-2 bg-stone-50 dark:bg-stone-800 px-3 py-1.5 rounded-lg border border-stone-200 dark:border-stone-700">
                                            <span className="text-xs font-bold text-stone-400 uppercase">Pos:</span>
                                            <input type="number" className="w-12 bg-transparent font-mono text-sm text-center outline-none dark:text-white" value={editOrderValues[item.id] !== undefined ? editOrderValues[item.id] : (item.order || 0)} onChange={e=>setEditOrderValues({...editOrderValues, [item.id]: e.target.value})} />
                                            <button onClick={() => handleUpdateOrder(item.id)} className="text-stone-400 hover:text-green-600 transition-colors"><Save size={14}/></button>
                                        </div>
                                        
                                        <div className="flex-grow"></div>

                                        <button onClick={() => startEdit(item)} className="p-2 text-stone-500 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors" title="Bearbeiten"><Edit2 size={18}/></button>
                                        <button onClick={() => handleDelete(item.id)} className="p-2 text-stone-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" title={t.admin.delete}><Trash2 size={18}/></button>
                                    </div>
                               </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

// --- 3. HAUPT-APP ---

const App = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [isAdminMode, setIsAdminMode] = useState(false);
  const [user, setUser] = useState(null);
  const [feedItems, setFeedItems] = useState(DEFAULT_POSTS);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [lang, setLang] = useState('de');
  const [views, setViews] = useState(0);

  const t = translations[lang];

  useEffect(() => {
     const unsubscribe = onAuthStateChanged(auth, u => setUser(u));
     return () => unsubscribe();
  }, []);

  // --- VIEW COUNTER LOGIC (HIT COUNTER) ---
  useEffect(() => {
     const viewDocRef = doc(db, 'artifacts', APP_ID, 'public', 'data', 'stats', 'views');
     
     // 1. Live-Update für den Admin
     const unsubViews = onSnapshot(viewDocRef, (snap) => {
         if (snap.exists()) {
             setViews(snap.data().count || 0);
         }
     });

     // 2. Zähler erhöhen
     setDoc(viewDocRef, { count: increment(1) }, { merge: true }).catch(err => console.log("Zähler-Fehler:", err));

     return () => unsubViews();
  }, []);

  useEffect(() => {
      const q = query(collection(db, 'artifacts', APP_ID, 'public', 'data', 'posts'));
      return onSnapshot(q, (snap) => {
          const docs = snap.docs.map(d => ({id: d.id, ...d.data()}));
          docs.sort((a,b) => (b.order || 0) - (a.order || 0));
          setFeedItems([...DEFAULT_POSTS, ...docs]);
      });
  }, []);

  const handleLogin = (e, p) => signInWithEmailAndPassword(auth, e, p);
  const handleLogout = () => { signOut(auth); setIsAdminMode(false); };
  const handleAdd = (d) => addDoc(collection(db, 'artifacts', APP_ID, 'public', 'data', 'posts'), {...d, authorId: user.uid});
  const handleDel = (id) => deleteDoc(doc(db, 'artifacts', APP_ID, 'public', 'data', 'posts', id));
  // Hier Update Logik für das Admin Panel (Caption Update)
  const handleUpd = (id, d) => updateDoc(doc(db, 'artifacts', APP_ID, 'public', 'data', 'posts', id), d);

  return (
    <div className={isDarkMode ? 'dark' : ''}>
        <div className="font-sans text-gray-900 dark:text-stone-100 bg-white dark:bg-stone-950 min-h-screen flex flex-col transition-colors duration-300">
            {isAdminMode && !user ? (
                <AdminLogin onLogin={handleLogin} t={t} />
            ) : isAdminMode && user ? (
                <AdminPanel items={feedItems} onAdd={handleAdd} onDelete={handleDel} onUpdate={handleUpd} onLogout={handleLogout} t={t} user={user} views={views} />
            ) : (
                <>
                    <Navigation activeTab={activeTab} setActiveTab={setActiveTab} isDarkMode={isDarkMode} toggleDarkMode={()=>setIsDarkMode(!isDarkMode)} lang={lang} toggleLang={()=>setLang(l=>l==='de'?'tr':'de')} t={t} />
                    <div className="flex-grow">
                        {activeTab === 'home' && <><Hero setActiveTab={setActiveTab} t={t}/><About t={t}/><Feed items={feedItems.slice(0,3)} t={t}/><Contact t={t}/></>}
                        {activeTab === 'about' && <About t={t}/>}
                        {activeTab === 'news' && <Feed items={feedItems} t={t}/>}
                        {activeTab === 'contact' && <Contact t={t}/>}
                    </div>
                    <Footer onAdminClick={()=>setIsAdminMode(true)} t={t}/>
                </>
            )}
        </div>
    </div>
  );
};

export default App;